// extracted by mini-css-extract-plugin
module.exports = {"c1q4xm40":"c1q4xm40"};